import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faClock } from '@fortawesome/pro-regular-svg-icons';
import { DialogNgbService, QuizModule, PipesModule } from '@motivforce/mx-library-angular';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/app/shared/shared.module';

import { AwardSalesDialogComponent } from './components/award-sales-dialog/award-sales-dialog.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { IprPromotionPopupDialogComponent } from './components/ipr-promotion-popup-dialog/ipr-promotion-popup-dialog.component';
import { PromotionTermsConditionsAcceptDialogComponent } from './components/promotion-terms-conditions-accept-dialog/promotion-terms-conditions-accept-dialog.component';
import { TermsConditionsAcceptDialogComponent } from './components/terms-conditions-accept-dialog/terms-conditions-accept-dialog.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';

@NgModule({
  declarations: [
    DialogComponent,
    TermsConditionsAcceptDialogComponent,
    ConfirmationDialogComponent,
    AwardSalesDialogComponent,
    PromotionTermsConditionsAcceptDialogComponent,
    IprPromotionPopupDialogComponent,
  ],
  imports: [
    CommonModule,
    NgbModalModule,
    RouterModule,
    QuizModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
    PipesModule,
  ],
  exports: [NgbModalModule],
})
export class DialogModule {
  constructor(private dialog: DialogNgbService, private iconlibrary: FaIconLibrary) {
    this.dialog.registerNotificationDialog(DialogComponent);
    this.dialog.registerErrorDialog(DialogComponent);
    this.dialog.registerWarningDialog(DialogComponent);
    this.dialog.registerValidationDialog(DialogComponent);
    this.dialog.registerConfirmationDialog(ConfirmationDialogComponent);

    this.dialog.registerFeatureDialog('termsConditionsAcceptDialog', TermsConditionsAcceptDialogComponent);
    this.dialog.registerFeatureDialog('awardSalesDialog', AwardSalesDialogComponent);
    this.dialog.registerFeatureDialog(
      'promotionTermsConditionsAcceptDialog',
      PromotionTermsConditionsAcceptDialogComponent
    );
    this.dialog.registerFeatureDialog('iprPromotionPopupDialog', IprPromotionPopupDialogComponent);
    this.iconlibrary.addIcons(faClock);
  }
}
